import React from 'react';
import { Button } from './';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { DOCUMENTATION } from '../constants/docLinks';

export const DocumentationLinksDropdown = ({ documentationType }) => {
    const { links: docLinks, labels: docLabels, buttonText } = DOCUMENTATION[documentationType] || {};

    const menuItems = Object.entries(docLinks).map(([key, url]) => ({
        key: key.toLowerCase(),
        label: (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {docLabels[key] || key}
            </a>
        ),
    }));

    return (
        <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
            <Button>
                {buttonText} <DownOutlined />
            </Button>
        </Dropdown>
    );
};
